export const getMapOptions = isFullScreen => {
  const winAvailable = typeof window !== 'undefined';

  const mapOptions = {
    fullscreenControl: false,
    zoomControl: isFullScreen,
    mapTypeControl: isFullScreen,
    streetViewControl: isFullScreen,
    streetViewControlOptions: {
      position: winAvailable && window.google?.maps?.ControlPosition?.RIGHT_TOP
    },
    zoomControlOptions: {
      position:
        winAvailable && window.google?.maps?.ControlPosition?.RIGHT_CENTER
    },
    mapTypeControlOptions: {
      style:
        winAvailable &&
        window.google?.maps?.MapTypeControlStyle?.HORIZONTAL_BAR,
      position: winAvailable && window.google?.maps?.ControlPosition?.TOP_RIGHT
    }
  };

  const mapStyle = {
    width: '100%',
    height: isFullScreen ? '100%' : '165px'
  };

  return {
    mapStyle,
    mapOptions
  };
};
